export default function AnnouncementServiceProvider() {
  const announcements = [];

  const provider = {
    add(announcement) {
      announcements.push(announcement);
    },
    $get($injector, Authentication, $uibModal, $q) {
      'ngInject';

      return {
        async _irrelevant(announcement, checkIfOpened) {
          if (checkIfOpened && this._opened) {
            return true;
          }

          if (
            !Authentication.user ||
            Authentication.user.settings.clientFlags[`${announcement.type}Announced`]
          ) {
            return true;
          }

          if (
            announcement.forUserRoles &&
            !announcement.forUserRoles.includes(Authentication.user.role)
          ) {
            return true;
          }

          return 'isIrrelevant' in announcement
            ? $injector.invoke(announcement.isIrrelevant)
            : false;
        },
        async show() {
          let resolveAllShown;
          this.allShownPromise = $q((resolve) => (resolveAllShown = resolve));

          for (const announcement of announcements) {
            if (!(await this._irrelevant(announcement, true))) {
              this._opened = true;
              try {
                await $uibModal.open({
                  templateUrl: announcement.html,
                  windowClass: announcement.windowClass || '',
                  backdrop: 'static',
                  keyboard: false,
                  size: announcement.modalSize,
                  controller: announcement.controller || (() => {}),
                  controllerAs: 'ctrl',
                }).result;
              } catch {
                //
              } finally {
                this._opened = false;
                await this.markAsShown(announcement);
              }
            }
          }

          resolveAllShown();
        },
        async markAsShown(announcement) {
          if (await this._irrelevant(announcement)) {
            return;
          }

          if (this._setAnnouncedFlag(announcement)) {
            Authentication.syncSettings();
          }
        },
        skipForNewUser(user) {
          announcements.forEach((announcement) => {
            if (announcement.skipForNewUser) {
              this._setAnnouncedFlag(announcement, user);
            }
          });
        },
        _setAnnouncedFlag(announcement, user = Authentication.user) {
          if (!announcement.isPermanent) {
            user.settings.clientFlags[`${announcement.type}Announced`] = true;
            return true;
          }

          return false;
        },
        allShown() {
          return this.allShownPromise || $q.resolve();
        },
      };
    },
  };

  if (__TEST__) {
    // if anyone has a cleaner idea (and can confirm it's working) then I'm all ears
    Object.assign(global._providers, { AnnouncementServiceProvider: provider }); // eslint-disable-line
  }

  return provider;
}
